export default {
  loadMore: {
    id: 'review_display_loadmore_reviews',
    defaultMessage: 'Show more reviews',
  },
  originalTitle: {
    id: 'review_display_all_reviews_title_new',
    defaultMessage: 'Customer reviews for {title} - Verified Purchases',
  },
  placeholderTitle: {
    id: 'review_display_placeholder_reviews_title',
    defaultMessage: 'Mondiovision customer reviews',
  },
  placeholderSubtitle: {
    id: 'review_display_placeholder_reviews_subtitle',
    defaultMessage:
      "Here's what our 2 million customers say about us around the world.",
  },
}
